"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconDefaultCopy = function IconDefaultCopy(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconDefaultCopy', className),
    style: style,
    viewBox: "0 0 17 22"
  }, _react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("path", {
    fill: "currentColor",
    fillOpacity: "0",
    d: "M-7-4h30v30H-7z"
  }), _react.default.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M1.595 21.25h13.81c.866 0 1.595-.723 1.595-1.582V6.285c0-.317-.137-.588-.319-.814L11.44.316C11.212.09 10.938 0 10.62 0H1.594C.73 0 0 .723 0 1.582v18.086c0 .859.684 1.582 1.595 1.582zm9.89-18.944l3.145 3.12h-2.917c-.137 0-.228-.09-.228-.227V2.306zM1.367 1.582c0-.135.091-.226.228-.226h8.569V5.2c0 .86.729 1.583 1.595 1.583h3.874v12.886c0 .135-.091.226-.228.226H1.595c-.137 0-.228-.09-.228-.226V1.582z"
  }), _react.default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.2",
    d: "M5.5 13l2 2 4-4"
  })));
};

var _default = IconDefaultCopy;
exports.default = _default;